{{ (isNegative ? '-' : '') + '£' + integral
}}<span
  *ngIf="fractional"
  class="semi-bold price-decimals"
  [style.color]="color_of_fraction"
  >.{{ fractional }}</span
>
